import { MfeComponent } from '@/common/MicroFrontEnds';
import useLoadSoftPullMfe from '@/common/Modals/SoftPullMfeModal/useLoadSoftPullMfe';
import { useIsLoggedIn } from '~/context/common/UserContext';
import { useEventListeners, useToggleModal } from './hooks';

// TODO: Replace with `src/components/common/Modals/SoftPullMfeModal/SoftPullMfeModal.tsx`
export default function SoftPullMfeModal() {
  const isLoggedIn = useIsLoggedIn();

  useLoadSoftPullMfe();
  useToggleModal();
  useEventListeners();

  return (
    <MfeComponent<{
      externalIsLoggedIn: boolean;
      softPullSource: string;
    }>
      component="default"
      module="SoftPullModule"
      softPullSource="Search"
      externalIsLoggedIn={isLoggedIn}
    />
  );
}
